<iframe #demosite height='100%' width='100%' [src]='safeUrl'></iframe>
<crchat-chatwidget *ngIf='demo' id="chatbox"
  [channel]='demo.tag' version=''
  options='{"isOpen":"false", "loadHistory":"true", "autoStart":"true"}'></crchat-chatwidget>
